<template>
    <div>
        <van-nav-bar class="nav-bar" title="发布需求" left-text="返回" left-arrow @click-left="$router.push({path:'/'})" />
        
        <div>
            <van-form ref="form" :rules="rules" >
                <van-field v-model="demandForm.requireTitle" name="需求标题" label="需求标题" placeholder="请输入需求标题" :rules="rules.requireTitle"/>
                <van-field v-model="demandForm.requireLabel" name="需求标签" label="需求标签" placeholder="请输入需求标签" :rules="rules.requireLabel"/>
                <van-field v-model="demandForm.linkName" name="联系人" label="联系人" placeholder="请输入联系人" :rules="rules.linkName"/>
                <van-field v-model="demandForm.linkPhone" name="联系电话" label="联系电话" placeholder="请输入联系电话" :rules="rules.linkPhone"/>
                <van-field v-model="demandForm.budget" name="资源预算" label="资源预算" placeholder="请输入资源预算" :rules="rules.budget"/>
                 <van-field
                    v-model="demandForm.requireDesc"
                    rows="2"
                    autosize
                    label="需求描述"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入需求描述"
                    show-word-limit
                    :rules="rules.requireDesc"
                />
                 <van-field
                    v-model="demandForm.remark"
                    rows="2"
                    autosize
                    label="备注"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入备注"
                    show-word-limit
                />
                
                <van-button class="submit-button" round block type="info" native-type="submit" @click="onSubmit()">提 交</van-button>
            </van-form>
            <!-- <div class="submit-button">
                
            </div> -->
        </div>
    </div>
</template>

<script>
import {
    releaseDemand
} from '@/api/index.js'
import { Toast } from 'vant';
export default {
    data() {
        return {
            demandForm:{
                requireTitle:"",//资源需求标题
                requireLabel:"",//资源需求标签
                linkName:"",//联系人
                linkPhone:"",//联系电话
                budget:"",//资源预算
                requireDesc:"",//资源需求描述
                remark:"",//备注
            },
            rules:{
                requireTitle:[
                    { required: true, message: '请输入需求标题' },
                ],
                requireLabel:[
                    { required: true, message: '请输入需求标签' },
                ],
                linkName:[
                    { required: true, message: '请输入联系人' },
                ],
                linkPhone:[
                    { required: true, message: '请输入联系电话' },
                ],
                budget:[
                    { required: true, message: '请输入资源预算' },
                ],
                requireDesc:[
                    { required: true, message: '请输入资源需求描述' },
                ],
            }
        };
    },

    mounted() {
        
    },

    methods: {
        onSubmit(){
            let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');//用户权限 /1个人需求 2公司需求 3资源 4渠道
            let data = {
                requireTitle:this.demandForm.requireTitle, //资源需求标题
                requireLabel:this.demandForm.requireLabel, //资源需求标签
                linkName:this.demandForm.linkName, //联系人
                linkPhone:this.demandForm.linkPhone, //联系电话
                budget:this.demandForm.budget, //资源预算
                requireDesc:this.demandForm.requireDesc, //资源需求描述
                remark:this.demandForm.remark, //备注
                userType:cloud_login_user_role, //资源需求类型 1:个人 2:企业
            }
            releaseDemand(data).then(res=>{
                if(res.data){
                    Toast.success('需求发布成功');//提示消息
                    //跳转返回首页
                    setTimeout(() => {
                        this.$router.push({path:'/'});
                    },1000)
                }else {
                    Toast.fail(res.message);
                }
            })
        }
    },
};
</script>
<style scoped>
.submit-button{
    width:90%;
    margin:20px auto;
}
</style>